import React from 'react';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../../../components/Buttons/ButtonBase';

const fields = [
    {
      name: 'name',
      label: 'Nombre(s)'
    },
    {
      name: 'lastName',
      label: 'Apellidos'
    },
];

const FormUpdatePasswordClient = props => {
    
    const {
      values,
      handleChange,
      handleBlur,
      handleSubmit,
      touched,
      errors,
      isValid,
    } = props;
  
    return (
      <form onSubmit={handleSubmit}>
        {fields.map(({ name, label }) => {
          return (
            <div key={name}>
              <TextField
                id={name}
                name={name}
                label={label}
                value={values[name]}
                onChange={handleChange}
                onBlur={handleBlur}
                type='text'
                helperText={touched[name] && errors[name] ? errors[name] : ''}
                error={touched[name] && errors[name] ? true : false}
                variant="outlined"
              />
            </div>
          );
        })}
        <br />
        <ButtonBase 
            type="submit"
            variant="primary"
            isValid={isValid}
        >
          Guardar Cambios
        </ButtonBase>
      </form>
    );
}

export default FormUpdatePasswordClient;